<div class="pdf-generator">
  <!-- Loading State -->
  <div *ngIf="isGenerating" class="loading-container">
    <mat-spinner diameter="40"></mat-spinner>
    <p>Gerando PDF...</p>
  </div>

  <!-- Error State -->
  <div *ngIf="errorMessage && !isGenerating" class="error-container">
    <mat-icon class="error-icon">error</mat-icon>
    <p class="error-message">{{ errorMessage }}</p>
    <button mat-raised-button color="warn" (click)="retryGeneration()">
      <mat-icon>refresh</mat-icon>
      Tentar Novamente
    </button>
  </div>

  <!-- Success State -->
  <div *ngIf="!isGenerating && !errorMessage" class="pdf-content">
    <!-- Preview Section -->
    <div *ngIf="showPreview && previewUrl" class="pdf-preview">
      <h3>Pré-visualização do PDF</h3>
      <iframe 
        [src]="previewUrl | safeUrl" 
        width="100%" 
        height="500px"
        frameborder="0"
        title="Pré-visualização do PDF">
      </iframe>
    </div>

    <!-- Action Buttons -->
    <div class="action-buttons">
      <button 
        mat-raised-button 
        color="primary" 
        (click)="downloadPDF()"
        [disabled]="isGenerating"
        class="download-button">
        <mat-icon>download</mat-icon>
        Baixar PDF
      </button>
      
      <button 
        *ngIf="showPreview && !previewUrl"
        mat-stroked-button 
        color="primary" 
        (click)="generatePreview()"
        [disabled]="isGenerating">
        <mat-icon>preview</mat-icon>
        Gerar Pré-visualização
      </button>
    </div>
  </div>
</div>

<!-- Exemplo de uso para relatório financeiro -->
<!-- 
<app-pdf-generator
  [data]="financialReportData"
  [config]="{
    type: 'financial',
    reportTitle: 'RELATÓRIO FINANCEIRO - FLUXO DE CAIXA'
  }"
  [showPreview]="true"
  [fileName]="'relatorio-financeiro.pdf'"
  (pdfGenerated)="onPdfGenerated($event)"
  (generationError)="onGenerationError($event)">
</app-pdf-generator>
-->

<!-- Exemplo de uso para ordem de serviço -->
<!-- 
<app-pdf-generator
  [data]="serviceOrderData"
  [config]="{
    type: 'service-order'
  }"
  [showPreview]="true"
  [fileName]="'ordem-servico.pdf'"
  (pdfGenerated)="onPdfGenerated($event)"
  (generationError)="onGenerationError($event)">
</app-pdf-generator>
-->
